
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 11 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#dce3e9","d":"M10.844.203a.61.61 0 01.15.492V3.67a.61.61 0 11-1.221 0V2.09L4.097 7.768a.61.61 0 11-.864-.864l5.676-5.676h-1.58a.61.61 0 110-1.222h2.975a.612.612 0 01.54.197zM4.886.006a.61.61 0 110 1.222H1.222v8.55h8.55V6.115a.61.61 0 111.222 0V9.78A1.23 1.23 0 019.773 11H1.222A1.23 1.23 0 010 9.78V1.228A1.23 1.23 0 011.222.006z"}})])
          )
        }
      }
    